export const classes = {
  errorClass: 'border-[0.5px] !border-[#E95344] font-[700]  !rounded-none bg-[#ff0000] text-white',
  warningClass: 'border-[0.5px] border-[#141414] font-[700]  !rounded-none bg-yellow text-black',
  generalClass: 'border-[0.5px] border-[#141414] text-[16px] !rounded-none',
  successClass: 'border-[0.5px] border-[#141414] text-[16px] font-[700] !rounded-none bg-[#90c14c] text-white',
};
